import axios from 'axios';

const baseURL = 'api/Configuration';

async function getAll() {
    const { data } = await axios.get(baseURL);
    return data;
};

export default { getAll };
